import { render, staticRenderFns } from "./caisseChooser.vue?vue&type=template&id=640a8d4a&"
import script from "./caisseChooser.vue?vue&type=script&lang=ts&"
export * from "./caisseChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports